import { render, staticRenderFns } from "./auth-finish-registration.vue?vue&type=template&id=108fadbc&scoped=true&"
import script from "./auth-finish-registration.vue?vue&type=script&lang=js&"
export * from "./auth-finish-registration.vue?vue&type=script&lang=js&"
import style0 from "./auth-finish-registration.vue?vue&type=style&index=0&id=108fadbc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108fadbc",
  null
  
)

export default component.exports